import { render, staticRenderFns } from "./touristPriceConfigModal.vue?vue&type=template&id=06c5cbfb"
import script from "./touristPriceConfigModal.vue?vue&type=script&lang=js"
export * from "./touristPriceConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports